import React, { Component } from "react";
import { Route, useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import '../../../common/report/reports/Invoice/invoice-table.component.css';
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import InventoryDetails from "../DetailsView/inventory-details-view.component";
import CreateRequestDisplay from "../../request/create-request/create-request-modal-display.component";
import RequestDetailDisplay from "../../request/request-details/request-details-modal-display.component";
import { linkedCircuitActions } from "../../../../store/external/inventory-reducer/linked-circuits.reducer";
import { inventoryCircuitActions } from "../../../../store/external/inventory/circuit.reducer";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils"

class LinkedCircuitDetailsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            selectedCircuit: undefined
        }
    }

    async componentDidMount() {
        const { getLinkedCircuitDetails, getInventoryCircuitDetail } = this.props;
        const { linkedCircuitID } = this.props.match.params;

        var data = await getLinkedCircuitDetails(linkedCircuitID);
        await getInventoryCircuitDetail(linkedCircuitID, data.CircuitTypeID, data.AccountID);

        this.setState({
            selectedCircuit: data,
            isLoaded: true
        });
    }

    handleCloseForm = () => {
        this.props.history.push("/external/Inventory/Circuit");
    }

    render() {
        const { linkedCircuitID } = this.props.match.params;
        const { isLoaded, selectedCircuit } = this.state;

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InventoryCircuitRW])

        return (
            <>
                {
                    isLoaded ?
                        <div className="invoice-wrapper-container inventory-report-component" >
                            <RequestHeaders headerTitle="circuit_details" />
                            <div className="request-table data-table">
                                <InventoryDetails
                                    closeForm={this.handleCloseForm.bind(this)}
                                    circuitId={linkedCircuitID}
                                    selectedCircuit={selectedCircuit}

                                    //Access Type
                                    isReadOnly={isReadOnly}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                >

                                    <Route exact path="/external/Inventory/Circuit/MyRequest/RaiseRequest/Order/:id" component={CreateRequestDisplay} />
                                    <Route exact path="/external/Inventory/History/MyRequest/RequestDetail/Order/:id" component={RequestDetailDisplay} />
                                </InventoryDetails>
                            </div>
                        </div>
                        : <NoSubscription />
                }
            </>
        )
    }
}

function LinkedCircuitDetails(props) {
    const history = useHistory();
    return <LinkedCircuitDetailsComponent {...props} history={history} />
}

export default connect(
    state => {
        const { inventoryLinkedCircuit } = state;
        return {
            ...inventoryLinkedCircuit
        }
    },
    dispatch => bindActionCreators(Object.assign({}, linkedCircuitActions, inventoryCircuitActions), dispatch)
)(LinkedCircuitDetails)